import { Action } from '@ngrx/store';

import * as authActions from '@auth/store/auth.actions';
import { ListEntry } from '@data/list-entry';
import { PCache } from '@data/pcache';
import * as orderActions from '@orders/store/orders.actions';

import * as tempdataActions from '../tempdata/tempdata.actions';

export const REINIT = '[PCACHE] - Re-initialize to bring in new defaults';
export const INV_SUM_SET_COL_PREF = '[INV SUM] [COL PREF] - Set Column Preferences';
export const INV_SUM_RESET_COL_PREF = '[INV SUM] [COL PREF] - Reset Column Preferences';
export const INV_DTL_SET_COL_PREF = '[INV DTL] [COL PREF] - Set Column Preferences';
export const INV_DTL_RESET_COL_PREF = '[INV DTL] [COL PREF] - Reset Column Preferences';
export const INV_LOT_SET_COL_PREF = '[INV LOT] [COL PREF] - Set Column Preferences';
export const INV_LOT_RESET_COL_PREF = '[INV LOT] [COL PREF] - Reset Column Preferences';
export const ORD_INQ_SET_COL_PREF = '[ORD INQ] [COL PREF] - Set Column Preferences';
export const ORD_INQ_RESET_COL_PREF = '[ORD INQ] [COL PREF] - Reset Column Preferences';
export const ORD_DTL_SET_COL_PREF = '[ORD DTL] [COL PREF] - Set Column Preferences';
export const ORD_DTL_RESET_COL_PREF = '[ORD DTL] [COL PREF] - Reset Column Preferences';
export const ORD_MOD_DTL_SET_COL_PREF = '[ORD MOD DTL] [COL PREF] - Set Column Preferences';
export const ORD_MOD_DTL_RESET_COL_PREF = '[ORD MOD DTL] [COL PREF] - Reset Column Preferences';
export const USER_LOOKUP_SET_COL_PREF = '[USER LOOKUP] [COL PREF] - Set Column Preferences';
export const USER_LOOKUP_RESET_COL_PREF = '[USER LOOKUP] [COL PREF] - Reset Column Preferences';
export const REPORT_LIST_SET_COL_PREF = '[REPORT LIST]] [COL PREF] - Set Column Preferences';
export const REPORT_LIST_RESET_COL_PREF = '[REPORT LIST] [COL PREF] - Reset Column Preferences';

export const ORDER_FILTER_UPSERT = '[ORD INQ] [FILTER] - Save Filter';
export const ORDER_FILTER_DELETE = '[ORD INQ] [FILTER] - Delete Filter';

export const ORDER_MODIFY_SET_FORM_DATA = '[ORDER MODIFY]] [FORM DATA] - Set Form Data';
export const ORDER_MODIFY_RESET_FORM_DATA = '[ORDER MODIFY] [FORM DATA] - Reset Form Data';

export class ReInit implements Action {
  readonly type = REINIT;
}

export class InvSumSetColPrefs implements Action {
  readonly type = INV_SUM_SET_COL_PREF;
  constructor(public colpref: any[]) {}
}

export class InvSumResetColPrefs implements Action {
  readonly type = INV_SUM_RESET_COL_PREF;
}

export class InvDtlSetColPrefs implements Action {
  readonly type = INV_DTL_SET_COL_PREF;
  constructor(public colpref: any[]) {}
}

export class InvDtlResetColPrefs implements Action {
  readonly type = INV_DTL_RESET_COL_PREF;
}

export class InvLotSetColPrefs implements Action {
  readonly type = INV_LOT_SET_COL_PREF;
  constructor(public colpref: any[]) {}
}

export class InvLotResetColPrefs implements Action {
  readonly type = INV_LOT_RESET_COL_PREF;
}

export class OrdInqSetColPrefs implements Action {
  readonly type = ORD_INQ_SET_COL_PREF;
  constructor(public colpref: any[]) {
  }
}

export class OrdInqResetColPrefs implements Action {
  readonly type = ORD_INQ_RESET_COL_PREF;
  constructor(public colpref: any[]) {}
}

export class OrdDtlSetColPrefs implements Action {
  readonly type = ORD_DTL_SET_COL_PREF;
  constructor(public colpref: any[]) {}
}

export class OrdDtlResetColPrefs implements Action {
  readonly type = ORD_DTL_RESET_COL_PREF;
}

export class OrdModDtlSetColPrefs implements Action {
  readonly type = ORD_MOD_DTL_SET_COL_PREF;
  constructor(public colpref: any[]) {}
}

export class OrdModDtlResetColPrefs implements Action {
  readonly type = ORD_MOD_DTL_RESET_COL_PREF;
}

export class UserLookupSetColPrefs implements Action {
  readonly type = USER_LOOKUP_SET_COL_PREF;
  constructor(public colpref: any[]) {}
}

export class UserLookupResetColPrefs implements Action {
  readonly type = USER_LOOKUP_RESET_COL_PREF;
}

export class ReportListSetColPrefs implements Action {
  readonly type = REPORT_LIST_SET_COL_PREF;
  constructor(public colpref: any[]) {}
}

export class ReportListResetColPrefs implements Action {
  readonly type = REPORT_LIST_RESET_COL_PREF;
}

export class OrderFilterUpsert implements Action {
  readonly type = ORDER_FILTER_UPSERT;
  constructor(public listEntry: ListEntry) {}
}

export class OrderFilterDelete implements Action {
  readonly type = ORDER_FILTER_DELETE;
  constructor(public id: string) {}
}

export class OrderModifySetFormData implements Action {
  readonly type = ORDER_MODIFY_SET_FORM_DATA;
  constructor(public formdata: PCache) {}
}

export class OrderModifyResetFormData implements Action {
  readonly type = ORDER_MODIFY_RESET_FORM_DATA;
  constructor(public id: string) {}
}

export type PCacheActions =
  | InvSumSetColPrefs
  | InvDtlSetColPrefs
  | ReInit
  | InvSumResetColPrefs
  | InvDtlResetColPrefs
  | OrdInqSetColPrefs
  | OrdInqResetColPrefs
  | OrderFilterUpsert
  | OrderFilterDelete
  | UserLookupSetColPrefs
  | UserLookupResetColPrefs
  | ReportListSetColPrefs
  | ReportListResetColPrefs
  | OrdDtlSetColPrefs
  | OrdDtlResetColPrefs
  | OrdModDtlSetColPrefs
  | OrdModDtlResetColPrefs
  | OrderModifySetFormData
  | OrderModifyResetFormData
  | authActions.ChangeCustomer
  | authActions.LoginInit
  | tempdataActions.OrdModHdrSetData
  | orderActions.OrdInqInit
  | orderActions.OrdInqReinit
  | orderActions.OrdModHdrCreateInboundSuccess
  | orderActions.OrdModHdrCreateOutboundSuccess
  | InvLotSetColPrefs
  | InvLotResetColPrefs;
